<!-- eslint-disable -->
<template>
  <div class="d-flex flex-column" style="height: 100%;">
    <!-- Title and navigation links -->
    <div class="pa-4 d-flex flex-wrap justify-space-between align-center flex-gap">
      <div>
        <Breadcrumbs
          :headline="$route.meta.title"
          :link="[
            {
              text: $route.meta.title
            }
          ]"
        />
      </div>
      <div>
        <v-btn v-if="$auth.policies['task-manage-add-task']" depressed dark color="#0D47A1" @click.stop="addNewTask">
          <v-icon left>add</v-icon> Thêm công việc
        </v-btn>
      </div>
    </div>
    <!-- Filter -->
    <v-card outlined v-if="allTasks && allTasks.length" class="task-filter-wrapper pa-4 mx-4 mb-4" elevation="0">
      <div class="task-filter-options">
        <v-radio-group v-model="taskFilter" hide-details="auto" class="ma-0 pa-0">
          <div class="contributor-filter">
            <v-radio class="ma-0" label="Công việc bạn tạo" value="filterByTaskCreator"></v-radio>
            <v-radio class="ma-0" label="Công việc bạn nhận" value="filterByTaskReceiver"></v-radio>
            <v-radio class="ma-0" label="Tất cả công việc" value="allTasks"></v-radio>
          </div>
        </v-radio-group>
      </div>
      <!-- <div class="search-button-wrapper">
        <v-btn class="search-button" dark outlined>
          Tìm kiếm
        </v-btn>
      </div> -->
    </v-card>
    <!-- Task container -->
    <div class="task-list-container mx-4 pb-3">
      <div class="task-list-wrapper">
        <div class="task-list-header px-3">
          <div class="task-list-title">Phải làm</div>
          <div class="task-count">{{ todoTasks.length }}</div>
        </div>
        <draggable class="overflow-y-auto draggable" v-model="todoTasks" v-bind="dragOptions" @end="onEnd">
          <transition-group list-name="todo" id="todo" class="task-list">
            <div v-for="task in todoTasks" :key="task.id" :class="taskWrapperClass(task)">
              <Task :task="task" @click="handleTaskClick" />
            </div>
          </transition-group>
        </draggable>
      </div>
      <div class="task-list-wrapper">
        <div class="task-list-header px-3">
          <div class="task-list-title">Đang làm</div>
          <div class="task-count">{{ doingTasks.length }}</div>
        </div>
        <draggable class="overflow-y-auto draggable" v-model="doingTasks" v-bind="dragOptions" @end="onEnd">
          <transition-group list-name="doing" id="doing" class="task-list">
            <div v-for="task in doingTasks" :key="task.id" :class="taskWrapperClass(task)">
              <Task :task="task" @click="handleTaskClick" />
            </div>
          </transition-group>
        </draggable>
      </div>
      <div class="task-list-wrapper">
        <div class="task-list-header px-3">
          <div class="task-list-title">Chờ đánh giá</div>
          <div class="task-count">{{ reviewTasks.length }}</div>
        </div>
        <draggable class="overflow-y-auto draggable" v-model="reviewTasks" v-bind="dragOptions" @end="onEnd">
          <transition-group id="review" class="task-list">
            <div v-for="task in reviewTasks" :key="task.id" :class="taskWrapperClass(task)">
              <Task :task="task" @click="handleTaskClick" />
            </div>
          </transition-group>
        </draggable>
      </div>
      <div class="task-list-wrapper">
        <div class="task-list-header px-3">
          <div class="task-list-title">Hoàn thành</div>
          <div class="task-count">{{ doneTasks.length }}</div>
        </div>
        <draggable class="overflow-y-auto draggable" v-model="doneTasks" v-bind="dragOptions" @end="onEnd">
          <transition-group id="done" class="task-list">
            <div v-for="task in doneTasks" :key="task.id" :class="taskWrapperClass(task)">
              <Task :task="task" @click="handleTaskClick" />
            </div>
          </transition-group>
        </draggable>
      </div>
    </div>
    <AddTaskDialog ref="add-task-dialog" @addTaskFinish="handleAddTask" />
    <TaskDetailDialog ref="task-detail-dialog" />
    <UpdateTaskDialog ref="update-task-dialog" />
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { isEmpty, get, find } from 'lodash'
import draggable from 'vuedraggable'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import Task from './modules/Task.vue'
import AddTaskDialog from './modules/AddTaskDialog'
import TaskDetailDialog from './modules/TaskDetailDialog'
import UpdateTaskDialog from './modules/UpdateTaskDialog.vue'

export default {
  components: {
    Task,
    draggable,
    Breadcrumbs,
    AddTaskDialog,
    TaskDetailDialog,
    UpdateTaskDialog
  },
  data() {
    return {
      allTasks: [],
      todoTasks: [],
      doingTasks: [],
      reviewTasks: [],
      doneTasks: [],
      taskFilter: 'allTasks'
    }
  },
  async created() {
    try {
      this.fetchTasks({ status: 'active' }).then(tasks => {
        if (!tasks) {
          this.$alert.error('Lấy dữ liệu công việc thất bại')
        }
      })
    } catch (error) {
      this.$alert.error('Lấy dữ liệu công việc thất bại')
      console.error(error)
    }
    this.fetchContributors()
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('task', ['tasks']),
    ...mapGetters('app', ['policies']),
    dragOptions() {
      return {
        animation: 0,
        group: 'task-group',
        ghostClass: 'ghost-item',
        chosenClass: 'chosen-item',
        dragClass: 'drag-item',
        filter: '.ignore-elements',
        preventOnFilter: false
      }
    }
  },
  methods: {
    ...mapActions('task', ['fetchContributors', 'fetchTasks', 'updateTask']),
    taskWrapperClass(task) {
      return {
        'ignore-elements': !task.draggable
      }
    },
    /**
     * Hàm phân bổ task fetch từ DB vào các category
     * Lọc các task theo task filter
     */
    generateTaskLists() {
      // Lọc các task theo điều kiện
      // Lọc các task theo người tham gia (Filter contributor radio)
      const filteredTasks = this.allTasks.filter(task => {
        // Lọc theo login user là người tạo task
        if (this.taskFilter === 'filterByTaskCreator') {
          return get(task, 'creator.id', '') === this.user.id
        }
        // Lọc theo login user là người nhận task
        if (this.taskFilter === 'filterByTaskReceiver') {
          return get(task, 'receiver.id', '') === this.user.id
        }
        // Tất cả các task mà login user có thể theo dõi
        return true
      })

      // Filter tasks by category
      const categories = ['todo', 'doing', 'review', 'done']
      categories.map(category => {
        this[`${category}Tasks`] = filteredTasks.filter(task => task.category === category)
        this[`${category}Tasks`].sort((a, b) => a.index - b.index)
      })
    },
    handleTaskClick(taskID) {
      this.$refs['task-detail-dialog'].openDialog(taskID)
    },
    addNewTask() {
      this.$refs['add-task-dialog'].openDialog(this.todoTasks.length)
    },
    handleAddTask() {
      this.fetchTasks({ status: 'active' })
    },
    /**
     * Hàm xử lý sự kiện drop của task sau khi drag
     */
    async onEnd(event) {
      // Vị trí tính theo thứ tự hiển thị trên màn hình, bắt đầu từ 0
      // Vị trí cũ của task trước khi kéo.
      const oldIndex = event.oldIndex
      // Vị trí mới được kéo đến
      const newIndex = event.newIndex
      // Lấy tên của list mà task được kéo khỏi
      const fromCategory = event.from.id
      // Lấy tên của list mà task được thả
      const toCategory = event.to.id
      // Task di chuyển
      const selectedTask = find(this.tasks, { id: event.item._underlying_vm_.id })

      let updateIndex = null // Biến lưu index sẽ save vào DB
      let updateCategory = null // Biến lưu category mới sẽ save vào DB

      // Di chuyển sang list khác
      if (fromCategory !== toCategory) {
        // Di chuyển task sang mục hoàn thành
        if (toCategory === 'done') {
          // Không phải người tạo task
          if (get(selectedTask, 'creator.id', '') !== this.user.id) {
            this.$alert.error('Bạn không thể di chuyển công việc này sang mục hoàn thành')
            this.generateTaskLists()
            return
          }
        }
        updateCategory = toCategory
        updateIndex = this.calculateUpdateIndex(this[`${toCategory}Tasks`], newIndex)
      } else {
        // Vị trí có thay đổi trong cùng một list
        if (oldIndex !== newIndex) {
          updateIndex = this.calculateUpdateIndex(this[`${toCategory}Tasks`], newIndex)
        }
      }

      // Task không di chuyển - Kéo xong thả luôn tại chỗ
      if (updateIndex === null) {
        return
      }

      const updateTaskData = { id: selectedTask.id }
      updateTaskData.index = updateIndex
      if (updateCategory) {
        updateTaskData.category = updateCategory
      }
      try {
        this.$loading.active = true
        await this.updateTask(updateTaskData)
        this.$loading.active = false
      } catch (error) {
        console.error(error)
      }
      if (fromCategory !== toCategory && toCategory === 'done') {
        this.$refs['update-task-dialog'].openDialog(selectedTask.id)
      }
    },
    calculateUpdateIndex(taskList, newIndex) {
      let updateIndex = null
      if (newIndex === 0) {
        // Di chuyển task lên đầu
        // List mới chỉ có 1 item
        if (taskList.length === 1) {
          updateIndex = 1
        } else {
          // Vị trí của item thứ 2
          const nextIndex = taskList[newIndex + 1].index
          updateIndex = nextIndex - 1
        }
      } else if (newIndex === taskList.length - 1) {
        // Di chuyển task xuống cuối
        // Vị trí của item thứ 2 từ dưới lên
        const prevIndex = taskList[newIndex - 1].index
        updateIndex = prevIndex + 1
      } else {
        // Vị trí thay đổi vào giữa 2 item
        const nextIndex = taskList[newIndex + 1].index
        const prevIndex = taskList[newIndex - 1].index
        if (nextIndex - prevIndex > 1) {
          // 2 item cách nhau hơn 1 đơn vị
          updateIndex = prevIndex + 1
        } else {
          updateIndex = (nextIndex + prevIndex) / 2
        }
      }
      return updateIndex
    }
  },
  watch: {
    tasks: {
      handler() {
        if (isEmpty(this.tasks)) {
          this.allTasks = []
          return
        }
        // Cho phép login user kéo thả các task mà có tham gia
        this.allTasks = this.tasks.map(task => {
          if (get(task, 'creator.id', '') === this.user.id || get(task, 'receiver.id', '') === this.user.id) {
            return {
              ...task,
              draggable: true
            }
          } else {
            return {
              ...task,
              draggable: false
            }
          }
        })
      },
      immediate: true
    },
    allTasks() {
      this.generateTaskLists()
    },
    taskFilter: {
      handler() {
        this.generateTaskLists()
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.flex-gap {
  gap: 16px;
}

// Filters
.task-filter-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  .task-filter-options {
    .contributor-filter {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
    }
  }
  .search-button-wrapper {
    margin-left: auto;
  }
}

.task-list-container {
  display: flex;
  gap: 28px;
  overflow: auto hidden;
  align-items: stretch;
  justify-content: space-between;
  flex-grow: 1;
}
.task-list-wrapper {
  flex: 1 0 275px;
  padding: 12px 5px 12px 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background-color: #f5f5f5;
  border: 1px solid #d3d3d3;
  border-radius: 8px;
  z-index: 1;
}
.task-list-header {
  font-size: 16px;
  line-height: 19px;
  font-weight: bold;
  color: #000;
  display: flex;
  justify-content: space-between;
}
.draggable {
  flex-grow: 1;
}
.task-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-right: 7px;
  height: 100%;
}

// Drag - drop class
.ghost-item {
  position: relative;
  opacity: 1 !important;
  border-radius: 4px;
}
.ghost-item .task-wrapper {
  visibility: hidden;
}
.ghost-item::after {
  content: ' ';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: grey;
  border-radius: 4px;
  opacity: 0.5;
}
.chosen-item {
  opacity: 1;
}
.drag-item {
  position: relative;
}
// .drag-item * {
//   opacity: 1 !important;
// }

.drag-item::after {
  content: ' ';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 1 !important;
}

// Custom scroll bar
/* width */
::-webkit-scrollbar {
  width: 8px;
  height: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #e0e0e0;
  border-radius: 4px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
